<div class="background-image"> 
  <!--<div class="container">-->
    <div class="jumbotron jumbotron-fluid"> 
        <ds-themed-text-section *ngIf="hasHomeNewsMetadata; else dsDefaultHomeNews" [sectionId]="'site'" [textRowSection]="homeNewsSection"
                                       [site]="(site$ | async)">
        </ds-themed-text-section>
    </div>        
  <!--</div>-->
</div> 

<ng-template #dsDefaultHomeNews>
  <!-- <div class="d-flex flex-wrap justify-content-start ml-auto"> -->   
        <div class="d-flex flex-wrap justify-content-start ml-auto" >      
            <h2>
                <p style="text-align:left; padding-left:50px; padding-right: 30px;"><b>Universiti Malaysia Perlis Research Repository</b></p>
            </h2>
            <h3>    
                <p style="text-align:left; padding-left:50px; padding-right: 30px;"> provides platform for UniMAP open access publication, research data and research expertise. </p>        
            </h3>
        </div>      
        <div >
            <h5>
              <ul style="list-style: none;">  
                <li><img src="assets/images/openaccess.png"> Open Access Publication</li>
                <li><img src="assets/images/hi-impact.png"> High-impact publications</li>
                <li><img src="assets/images/research data.png"> Research Data / Open Data</li>
                <li><img src="assets/images/researcher1.png"> Researcher</li>        
                <li><img src="assets/images/ris.png"> Research Information System</li>
              </ul>
            </h5>         
        </div>           
</ng-template>


